import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import IServiceQueue, { IServiceQueueInput } from "@/interfaces/service-queue.interface";
import serviceQueueService from "@/services/service-queue.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateServiceQueueProps = {
  formData: IServiceQueueInput;
} & RequestsProps;

export type Return = {
  create: (props: CreateServiceQueueProps) => Promise<IServiceQueue>;
} & UseLoadingReturn;

const useCreateServiceQueue = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<IServiceQueueInput>({
      operation: (formData) => serviceQueueService.create(formData),
    });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateServiceQueue;
